// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"fdbdb63e","1997":"84998110","2510":"fdbdb63e","3936":"fdbdb63e","6050":"fdbdb63e","7223":"fdbdb63e"}[chunkId] + ".chunk.css";
};